import { IStateProvider } from 'angular-ui-router';

import { SdcStateBuilder } from './sdc-state-builder.service';

DefaultSdcRouteConfig.$inject = ['$stateProvider'];

const SDC_KEY = 'default-sdc';

export function DefaultSdcRouteConfig($stateProvider: IStateProvider) {
  const defaultSdcGridState = SdcStateBuilder.buildGridState(SDC_KEY);
  const defaultSdcProfileState = SdcStateBuilder.buildProfileState(SDC_KEY);

  $stateProvider

    .state(`main.school.new-sdc.${SDC_KEY}`, {
      abstract: true,
      url: `/${SDC_KEY}`,
      template: `
      <sdc-root
      current-user="$resolve.currentUser"
      current-state="$resolve.currentState">
      </sdc-root>
        `,
    })

    .state(`main.school.new-sdc.${SDC_KEY}.grid`, defaultSdcGridState)
    .state(`main.school.new-sdc.${SDC_KEY}.profile`, defaultSdcProfileState);
}
